
/**
 * @author Andrew Gower <amogower@gmail.com>
 */

import APIRequest from '../APIRequest';

import { USERS } from '../constants';

/**
 * User Class
 * @constructor
 * @param {Object} store - The store object
 * @param {Object} data - The main data object
 * @param {Object} relationships - The related data object
 */
export default class User extends APIRequest {
    constructor(store, dataObj) {
        if (!store) {
            throw new Error('User->constructor: config - ', store);
        }
        super(store, USERS, dataObj);
    }

    type = USERS

    /**
     * The API method for getting a user by ID
     * @returns {Object} The user object
     */
    async authMe() {
        this.method = 'GET';
        this.url = 'auth/me';
        return this.launchRequest();
    }

    /**
     * The API method for getting a users venues
     * @returns {Array} An array of venues
     */
    getVenues() {
        this.method = 'GET';
        this.url = `${this.type}/${this.body.data.attributes.id}/venues`;
        this.includes = [
            'images'
        ];
        return this.launchRequest();
    }
}



// WEBPACK FOOTER //
// ./src/API/User/User.js